import { Component, Inject, OnInit } from '@angular/core';
import { UntypedFormBuilder } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { AppInfoService } from 'core/app-info/app-info.service';
import { CountryCode } from 'core/app-info/country-specifics.enum';
import { AppLocalization } from 'src/app/modules/shared/entities/app-localization';
import { QuoteDetailsService } from '../services/quote-details.service';

@Component({
  selector: 'app-quote-atp',
  templateUrl: './quote-atp.component.html',
  styleUrls: ['./quote-atp.component.scss'],
  standalone: false
})
export class QuoteAtpComponent implements OnInit {
  selectForm;
  isMobile: boolean;
  atpValues: any;
  partNumber: string;
  selectedInventories: any[];
  selected;
  isLoading = true;
  isUkCountry: boolean;
  appStrings: AppLocalization;

  displayedColumns = [
    'availableQuantity',
    'receiptDate'
  ];

  constructor(
    public dialogRef: MatDialogRef<QuoteAtpComponent>,
    private appInfoService: AppInfoService,
    private quoteAtpService: QuoteDetailsService,
    private formBuilder: UntypedFormBuilder,
    private deviceService: DeviceDetectorService,
    @Inject(MAT_DIALOG_DATA) public data: any) {
    this.partNumber = data.partNumber;
  }

  ngOnInit() {
    this.appStrings = this.appInfoService.appStrings;
    this.isMobile = this.deviceService.isMobile();
    this.isUkCountry = this.appInfoService.userData?.UserInfo?.CountryCode === CountryCode.UK;
    this.selectedInventories = [];
    this.selectForm = this.formBuilder.group({
      defaultOption: [this.selected]
    });
    this.quoteAtpService.getAllAtp(this.partNumber, atpValues => {
      this.atpValues = atpValues;
      this.selected = atpValues[0];
      if (this.selected) {
        this.selectedInventories = this.selected.inventories;
      } else {
        this.selectedInventories = null;
      }
      this.selectForm.controls.defaultOption.setValue(this.selected);
      this.isLoading = false;
    });
  }

  warehouseChanged(selectedInventories) {
    if (this.selectedInventories) {
      this.selectedInventories = selectedInventories.inventories;
    } else {
      this.selectedInventories = null;
    }
  }

  /**
   * Returns the index of the pressed button. This should be used by the subscriber function to identify the button
   * @param buttonIndex the index of the pressed button
   */
  close(): void {
    this.dialogRef.close();
  }
}
